export const SYSTEM_PLAYBACK_SPEED_OPTIONS: ReadonlyArray<{ label: string; value: number }> = [
  { label: '100%', value: 1 },
  { label: '75%', value: 0.75 },
  { label: '50%', value: 0.5 },
  { label: '25%', value: 0.25 },
];

export const SYSTEM_PLAYBACK_SPEED_STORAGE_KEY = 'naati-system-playback-rate';

const ALLOWED = new Set(SYSTEM_PLAYBACK_SPEED_OPTIONS.map((o) => o.value));

export function readStoredSystemPlaybackRate(): number {
  try {
    const raw = localStorage.getItem(SYSTEM_PLAYBACK_SPEED_STORAGE_KEY);
    if (!raw) return 1;
    const value = Number(raw);
    return ALLOWED.has(value) ? value : 1;
  } catch {
    return 1;
  }
}

export function storeSystemPlaybackRate(value: number): void {
  if (!ALLOWED.has(value)) return;
  try {
    localStorage.setItem(SYSTEM_PLAYBACK_SPEED_STORAGE_KEY, String(value));
  } catch {
    /* ignore */
  }
}

export function applySystemPlaybackRate(audio: HTMLAudioElement | null, rate: number): void {
  if (!audio || !ALLOWED.has(rate)) return;
  audio.playbackRate = rate;
  audio.defaultPlaybackRate = rate;
}
